module.exports = __webpack_public_path__ + "img/modular-coding.094a4044.svg";